export var max = Math.max;
export var min = Math.min;
export var round = Math.round;


//////////////////
// WEBPACK FOOTER
// /home/riforce/domains/riforce.nl/releases/20250205091926/node_modules/@popperjs/core/lib/utils/math.js
// module id = 14
// module chunks = 0